import * as React from 'react';

// useCombinedRefs allows a component to receive
// a forwardRef, but also specify its own ref
// and combine the two

export function useCombinedRefs<T extends Element | null>(
  innerRef: React.MutableRefObject<T | null>,
  fwdRef: React.ForwardedRef<T>
) {
  React.useEffect(() => {
    [innerRef, fwdRef].forEach((ref) => {
      if (ref) {
        // forward ref flavor
        if (typeof ref === 'function') {
          ref(innerRef?.current || null);
        } else {
          // eslint-disable-next-line no-param-reassign
          ref.current = innerRef?.current || null;
        }
      }
    });
  }, [innerRef, fwdRef]);

  return innerRef || fwdRef;
}
